<app-card appVisible [visible$]="visible$">
  @if ((data$ | async) && !loading && !error && !(data$ | async)?.telemetryCharts?.graph?.message) {
    <div class="graph-tabs">
      <app-tabs [tabs]="tabs" [selected$]="selectedTab$"></app-tabs>

      <div class="graph-options d-flex">
        <div class="settings">
          <div ngbDropdown>
            <button ngbDropdownToggle class="btn dropdown-toggle border-0" type="button">
              <i class="bi bi-sliders"></i>
            </button>
            <ul ngbDropdownMenu class="dropdown-menu bg-white">
              <li>
                <div class="dropdown-item">
                  <app-toggle
                    [disabled]="loading"
                    class="text-small"
                    [ngModel]="showAnnotations$ | async"
                    (ngModelChange)="toggleAnnotations($event)"
                    >Limieten weergeven</app-toggle
                  >
                </div>
              </li>
              <li>
                <div class="dropdown-item">
                  <app-toggle
                    [disabled]="loading"
                    class="text-small"
                    [ngModel]="zoomEnabled$ | async"
                    (ngModelChange)="toggleZoom($event)"
                    >Zoomfunctie inschakelen</app-toggle
                  >
                </div>
              </li>
            </ul>
          </div>
        </div>
        @if (graphInfo) {
          <button class="btn border-0" type="button">
            <i
              class="bi bi-info-circle"
              tabindex="0"
              role="button"
              (click)="showGraphInfo(graphInfo)"
              (keydown)="showGraphInfo(graphInfo)"
              aria-label="Toon grafiek informatie"
            ></i>
          </button>
        }
      </div>
    </div>
    <div class="graph" [class.small]="small">
      <div class="d-flex">
        <app-graph
          [data$]="graphData$"
          [period]="(dashboardParams$ | async)!.period!"
          [config]="config"
          [showAnnotations]="(showAnnotations$ | async) ?? false"
          [zoomEnabled]="(zoomEnabled$ | async) ?? false"
          [class.small]="small"
        >
        </app-graph>
      </div>
    </div>
  }
  @if (loading) {
    <div class="row w-100 placeholder-glow">
      <div class="d-flex text-small">
        @for (i of [].constructor(3); track $index) {
          <div class="tab">
            <span class="fs-6 placeholder"></span>
          </div>
        }
      </div>
      <div class="graph d-flex flex-column flex-grow-1 gap-3" [class.small]="small">
        <div class="legend d-flex flex-wrap gap-3 pt-2">
          @for (i of [].constructor(3); track $index) {
            <span class="color placeholder"></span>
            <span class="text placeholder"></span>
          }
        </div>
        <div class="graph-wrapper d-flex flex-grow-1">
          <span class="unit placeholder"></span>
          <div class="bar-wrapper d-flex justify-content-around align-items-end flex-grow-1 ps-1 pb-1">
            @for (i of placeholderData; track $index) {
              <span class="bar placeholder w-100" [style]="{ height: i * 10 + '%' }"></span>
            }
          </div>
        </div>
      </div>
    </div>
  }
  @if ((data$ | async)?.telemetryCharts?.graph?.message) {
    <app-graph-placeholder [message]="(data$ | async)?.telemetryCharts?.graph?.message"></app-graph-placeholder>
  }
  @if (error) {
    <app-error-message [error]="error"></app-error-message>
  }
</app-card>
